import type { ReactNode } from "react";
import { cn } from "../../lib/cn";

interface Props {
  children: ReactNode;
  className?: string;
}

/** Small monospace keyboard hint chip — bg-inset on bg-surface contexts. */
export function Kbd({ children, className }: Props) {
  return (
    <kbd
      className={cn(
        "inline-flex items-center justify-center px-1.5 h-[18px]",
        "rounded-sm bg-bg-inset text-text-tertiary",
        "font-mono text-[11px] leading-none border border-border-subtle",
        className,
      )}
    >
      {children}
    </kbd>
  );
}
